import { action, computed, observable } from 'mobx';

import {
    Apertura,
    AperturaExclusion,
    Months,
    ConsultaApertura,
    ConsultaAperturaResponse
} from '../models';
import { FiltrosConsultaAperturas } from '../models/Consultas';
import requestStore from './requestStore';
import consultaStore from './consultaStore';
import moment from 'moment';

export class AperturaStore implements Apertura {
    @observable
    ejercicio: number = 0;

    @observable
    mes: number = 0;

    @observable
    fechaInicio: string = '';

    @observable
    fechaFin: string = '';

    @observable
    aperturaExclusion: AperturaExclusion | undefined;

    @observable
    listaAperturas: ConsultaApertura[] = [];

    @observable
    cargando: boolean = false;

    @observable
    filtrosConsultaAperturas: FiltrosConsultaAperturas = {
        ejercicio: 0,
        mes: 0
    };

    @observable
    ultimoMesActivo: number = 0;

    @action
    saveApertura(aperturaData: Apertura) {
        Object.assign(this, aperturaData);

        if (this.aperturaExclusion) {
            this.fechaInicio = this.aperturaExclusion.fechaInicio;
            this.fechaFin = this.aperturaExclusion.fechaFin;
        }
    }

    @computed
    get period() {
        return `${this.monthString} - ${this.ejercicio}`;
    }

    @computed
    get apertura() {
        if (this.hasAperturaInformation) {
            return `${this.shortFechaInicio} ~ ${this.shortFechaFin}`;
        }
        return '';
    }

    @computed
    get monthString() {
        return Months[this.mes - 1];
    }

    @computed
    get hasAperturaInformation() {
        return this.fechaInicio !== '' && this.fechaFin !== '';
    }

    @computed
    get isCurrentAperturaOpen() {
        return (
            Date.now() >= Date.parse(this.fechaInicio) && Date.now() <= Date.parse(this.fechaFin)
        );
    }

    @computed
    get shortFechaInicio() {
        return new Date(this.fechaInicio).toISOString().substring(0, 10);
    }

    @computed
    get shortFechaFin() {
        return new Date(this.fechaFin).toISOString().substring(0, 10);
    }

    @action
    async getListaAperturas() {
        this.cargando = true;
        this.listaAperturas = [];
        const response = await requestStore!.getAperturas(
            this.filtrosConsultaAperturas.ejercicio,
            this.filtrosConsultaAperturas.mes
        );
        if (response) {
            let elemento: ConsultaApertura = {
                id: 0,
                mesString: '',
                fechaInicio: '',
                fechaFin: '',
                mes: 0,
                ejercicio: 0
            };

            response.forEach(
                a => (
                    (elemento.id = a.id),
                    (elemento.mes = a.mes),
                    (elemento.ejercicio = a.ejercicio),
                    (elemento.mesString = consultaStore!.mesString(a.mes)),
                    (elemento.fechaInicio = moment(a.fechaInicio).format('DD/MM/YYYY')),
                    (elemento.fechaFin = moment(a.fechaFin).format('DD/MM/YYYY')),
                    this.listaAperturas.push(elemento)
                )
            );
            if (this.filtrosConsultaAperturas!.mes != 0 && this.listaAperturas[0].id == 0) {
                requestStore!.mostrarNotificacion(
                    'error',
                    'La apertura del mes de ' +
                        consultaStore!.mesString(this.filtrosConsultaAperturas!.mes) +
                        ' no se encuentra registrada en la base de datos, por favor de click en guardar después de seleccionar la vigencia'
                );
            }
        }
        this.cargando = false;
    }

    @action
    async insertarAperturas() {
        const response = await requestStore!.postInsertarAperturas(this.listaAperturas);
        if (response) {
            await this.getListaAperturas();
        }
    }

    @action
    limpiarFiltrosConsulta() {
        this.filtrosConsultaAperturas!.ejercicio = 0;
        this.filtrosConsultaAperturas!.mes = 0;
    }

    @action
    async obtenerUltimaApertura() {
        const fecha = new Date();
        this.filtrosConsultaAperturas.ejercicio = fecha.getFullYear();
        await this.getListaAperturas();
        const fechaActual =
            fecha.getDate() +
            '/' +
            (parseInt(fecha.getMonth().toString()) + 1).toString() +
            '/' +
            fecha.getFullYear();
        const listaFiltros = this.listaAperturas.filter(
            a =>
                a.id != 0 &&
                moment(a.fechaInicio, 'DD/MM/YYYY') <= moment(fechaActual, 'DD/MM/YYYY')
        );
        const mes = listaFiltros[listaFiltros.length - 1].mes;
        this.ultimoMesActivo = mes;
        this.listaAperturas = [];
        this.limpiarFiltrosConsulta();
    }
}

export const aperturaStore = new AperturaStore();
